<template>
    <div>
        <b-row>
            <b-col>
                <b-table hover small show-empty class="sr-caption"
                    aria-live="polite"
                    responsive="true"
                    :fields="attachmentFields"
                    :items="value"
                    :busy="false"
                    label-sort-asc=""
                    label-sort-desc=""
                    caption="Attachments table.  To sort the data in this table by a specific column,
                                       go to the appropriate column header cell and use enter to sort the data ascending.
                                       Use enter again to sort descending.">
                    <template v-slot:no-data>
                        No Attachments Found.
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <template v-slot:cell(actions)="row">
                        <b-button size="sm" @click="downloadAttachment(row)" target="_attach" class="mr-1">
                            Download
                        </b-button>
                    </template>
                    <template slot="empty" slot-scope="scope">
                        No Attachments Found.
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from 'axios';

export default {
    data() {
        return {
            attachmentFields:  [

            ],
        }
    },
    props: {
        value: Array,
        type: String,
    },
    created() {
        this.attachmentFields = [
            {key: 'filename', sortable: true, label: 'File Name'},
            {key: 'type.description', sortable: true, label: 'File Type'},
            {key: 'actions', label: 'Actions'},
        ]
    },
    methods:{
        downloadAttachment(row){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/${this.type}/`+row.item.attachmentId)
                .then(response=>{
                    if(response.data){
                        window.open(response.data,"_blank");
                    }
                    else{this.$emit('attachment-get-failure')}
                })
        }
    }
}
</script>

<style>
</style>
